export default "__VITE_ASSET__dFIkZal___"